module.exports = __webpack_public_path__ + "static/media/22_tn.184257db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/22_tn.jpg
// module id = 236
// module chunks = 0